<gl-base-modal (closeModal)="close()" class="customerResearchPopup">
  <h2 class="title">{{ 'customer_research_header' | translate }}</h2>
  <p class="message">{{ 'customer_research_body' | translate }}</p>
  <div class="buttons center">
    <button normal-outline-button (click)="openSurvey()">{{ 'customer_research_cta' | translate }}</button>
  </div>
</gl-base-modal>
